import styled from 'styled-components';

const ListSubscribers = styled.ul`
	padding: 0;
	list-style: none !important;

	li {
		display: flex;
		flex-flow: row nowrap;
		place-content: center space-between;
		//max-width: 420px;
		justify-content: space-between;
		align-items: center;
		padding: 0px 0px 0px 0;
		margin-bottom: 8px;
		font-size: 19px;

		button {
			display: flex;
			justify-content: center;
			align-items: center;
			color: ${({ theme }) => theme.colorListSubscribers} !important;
			border-radius: 50%;
			font-size: 14px;
			padding: 0;
		}

		span {
			border-left: 0px solid ${({ theme }) => theme.colorListSubscribers};
			padding-left: 0px;
			color: hsl(0, 0%, 15%);
			font-size: 13px;
			font-family: ${({ theme }) => theme.fontFamilyListSubscribers};
			font-weight: ${({ theme }) => theme.fontWeightListSubscribers};
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
			width: 320px;
		}

		small {
			font-family: ${({ theme }) => theme.fontFamilyListSubscribers};
			font-weight: ${({ theme }) => theme.fontWeightListSubscribers};
			color: ${({ theme }) => theme.colorListSubscribers};
			padding-left: 8px;
		}

		div {
			width: 85%;
			display: flex;
			flex-direction: column;
			flex-wrap: nowrap;
			align-items: baseline;
		}
	}

	button {
		border: 0;
		font-size: 22px;
		color: ${({ theme }) => theme.colorListSubscribers};
		background: transparent;
	}

	.FaRegEdit {
		color: ${({ theme }) => theme.colorListSubscribersFaRegEdit};
	}

	.FaTrashAlt {
		color: ${({ theme }) => theme.colorListSubscribersFaTrashAlt};
	}

	.visible {
		display: inline;
	}

	@media (max-width: 512px) {
		.visible {
			display: none;
		}

		li {
			span {
				width: 193px;
			}
		}
	}

	@media (max-width: 320px) {
		li {
			span {
				width: 135px;
			}
		}
	}

	@media (max-width: 280px) {
		li {
			span {
				width: 133px;
			}
		}
	}

	@media (min-width: 768px) and (max-width: 1023px) {
		.FaRegEdit {
			margin-left: 10px;
		}
	}
`;

export default ListSubscribers;
